import {
  CHECK_LIST,
  CHECK_FILTER,
  CHECK_UPDATE,
  CONSIGNMENT_LIST,
  CONSIGNMENT_FILTER,
  CONSIGNMENT_LIST_SUCCESS,
  CHECK_UPDATE_SUCCESS,
  CHECK_LIST_SUCCESS,
  PAYMENT_REQUEST_FAILED,
  CONSIGNMENT_UPDATE,
  CONSIGNMENT_UPDATE_SUCCESS,
} from "store/payments/actionTypes";

export const checkList = () => {
  return {
    type: CHECK_LIST,
    payload: {},
  };
};

export const checkFilter = (changeUrl) => {
  return {
    type: CHECK_FILTER,
    payload: { changeUrl },
  };
};

export const checkUpdate = (id, data) => {
  return {
    type: CHECK_UPDATE,
    payload: { id, data },
  };
};

export const consignmentList = () => {
  return {
    type: CONSIGNMENT_LIST,
    payload: {},
  };
};

export const consignmentFilter = (changeUrl) => {
  return {
    type: CONSIGNMENT_FILTER,
    payload: { changeUrl },
  };
};

export const consignmentUpdate = (id, data) => {
  return {
    type: CONSIGNMENT_UPDATE,
    payload: { id, data },
  };
};

export const checkListSuccess = (checks) => {
  return {
    type: CHECK_LIST_SUCCESS,
    payload: checks,
  };
};

export const checkUpdateSuccess = (check) => {
  return {
    type: CHECK_UPDATE_SUCCESS,
    payload: check,
  };
};

export const consignmenListSuccess = (consignments) => {
  return {
    type: CONSIGNMENT_LIST_SUCCESS,
    payload: consignments,
  };
};

export const consignmentUpdateSuccess = (consignment) => {
  return {
    type: CONSIGNMENT_UPDATE_SUCCESS,
    payload: consignment,
  };
};

export const paymentRequestFailed = (error) => {
  return {
    type: PAYMENT_REQUEST_FAILED,
    payload: error,
  };
};
